module.exports = __webpack_public_path__ + "static/mbb-logo-1-76d29c8d3bf9448289d4970412f7cb58.png";